import { FC } from "react";

const DropdownPossibleNextStep: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown nxtStep-Statuscolors-li">
      <button className="btn btn-link nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
          <span className="d-none d-lg-inline-block">Possible "Next Steps"</span>
          <span className="d-inline-block d-lg-none">Next Steps</span>
      </button>

      <ul className="next-step-dropdown dropdown-menu dropdown-menu-end p-3 p-md-4 shadow position-absolute">
        <p className="m-0">
          On the case screen, you can see a new column labeled "Next Steps" ...
          These new options allow you to update your cases without the need to contact FlexForward.
          The actions available are as follows:
        </p>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-5 my-1 text-white">Precert</span>
            </div>
            <div className="col-sm-8">
              Clicking "Precert" allows you to upload clinicals and enter information for the precert as well as submit
              it to the plan or request it be completed on your behalf.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-5 my-1 text-white">Review PA</span>
            </div>
            <div className="col-sm-8">
              Clicking "Review PA" allows you to review the transcribed PA and request changes or, alternatively, submit
              the prior authorization form presented directly to the insurance.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <button className="btn bg-primary text-white" type="button">Treatment Decision</button>
            </div>
            <div className="col-sm-8">
              Clicking "Treatment Decision" will allow you to specify whether or not you are treating the patient, as
              well as the date of treatment or the reason for not treating
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-3 my-1 text-white">Xfer to SP</span>
            </div>
            <div className="col-sm-8">
              Clicking "Xfer to SP" Transfers the prescription through the Specialty pharmacy Channel.
            </div>
          </div>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-3 my-1 text-white">Buy & Bill</span>
            </div>
            <div className="col-sm-8">
              Clicking "Buy & Bill" Changes the case status to "Office Buy & Bill"
            </div>
          </div>
        </li>
         <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-copay">Copay Claim</span>
            </div>
            <div className="col-sm-8">
              Clicking "Copay Claim" allows you to initiate a copay claim for reimbursement by uploading the EOB and CMS 1500 Claim form.
            </div>
          </div>
        </li>


      </ul>
    </li>
  );
};

export default DropdownPossibleNextStep;
